// Note: localization for MUI data grid and MUI date picker can be added into this file too.

import { deDE, enUS, esES, frFR, jaJP, ptBR, zhCN, Localization } from '@mui/material/locale';

export const muiLocales: Record<string, Localization[]> = {
  de: [deDE],
  en: [enUS],
  es: [esES],
  fr: [frFR],
  ja: [jaJP],
  pt: [ptBR],
  zh: [zhCN],
};
